import { Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useActivityQuizzesForSelector } from '@/store';
import { handleInputValue } from '@/utils';

type Props = {
  value?: string;
  courseId?: string;
  placeholder?: string;
  allowClear?: boolean;
  fallbackLabel?: string;
  onChange?: (value: string) => void;
};

export const QuizActivitySelector: React.FC<Props> = ({
  courseId,
  allowClear,
  placeholder,
  value,
  fallbackLabel,
  onChange
}) => {
  const { quizzes = [] } = useActivityQuizzesForSelector(courseId);
  const { t } = useTranslation('StudentQuizTranslations');

  const options = useMemo(() => {
    const baseOptions = quizzes.map(quiz => ({
      label: `(${t(quiz.mode)}) - ${quiz.title}`,
      value: quiz._id
    }));
    const resolvedValue = handleInputValue(value);
    const isValueInOptions = baseOptions.some(opt => opt.value === resolvedValue);
    if (resolvedValue && fallbackLabel && !isValueInOptions) {
      return [...baseOptions, { label: fallbackLabel, value: resolvedValue, disabled: false }];
    }
    return baseOptions;
  }, [quizzes, t, value, fallbackLabel]);

  return (
    <Select
      showSearch
      options={options}
      onChange={onChange}
      allowClear={allowClear}
      placeholder={placeholder}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      value={handleInputValue(value) ?? undefined}>
      {options.map(option => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
};
